;(function() {
  'use strict'

  service.$inject = ["$transitions", "$log", "$q", "$timeout", "glDialog", "postsResource", "userService", "shareService", "Message"];
  angular.module('core.services').factory('messageService', service)

  /* @ngInject */
  function service(
    $transitions,
    $log,
    $q,
    $timeout,
    glDialog,
    postsResource,
    userService,
    shareService,
    Message
  ) {
    var log = $log.create('messageService')
    var user = userService.get()

    return {
      create: create,
      getById: getById,
      close: close,
      flag: flag,
      flagComment: flagComment,
      share: share,
      showSendDialog: showSendDialog,
    }

    function create(options) {
      // create a brand spanking new message

      return new Message(options)
    }

    function getById(id, token, markAsRead) {
      return $q(function(resolve, reject) {
        // remove token if logged in

        if (token && user.id) {
          token = undefined
          log.info('ignoring token (user is logged-in)')
        }

        // fetch a message by ID

        var data = {
          id: id,
          accessToken: token,
        }

        postsResource
          .get(data)
          .success(function(resource, resp) {
            // inject any token we might be using

            resp.token = token

            // create and resolve with the message model

            var message = new Message().fromServer(resp)
            resolve(message)

            // mark as read (if needed)

            if (markAsRead === true || _.isNumber(markAsRead)) {
              // mark with delay

              if (_.isNumber(markAsRead)) {
                var timer = $timeout(function() {
                  message.markAsRead()
                }, markAsRead)

                // stop on state change!

                var deregister = $transitions.onStart(null, function() {
                  $timeout.cancel(timer)
                  deregister()
                })

                // mark immediately
              } else {
                message.markAsRead()
              }
            }
          })
          .error(function(data, status) {
            reject({
              data: data,
              status: status,
            })
          })
      })
    }

    function close(message) {
      return glDialog
        .show({
          templateUrl: 'message-close-dialog.template.html',
          controller: 'MessageCloseDialog', // bug: locals dont work without this
        })
        .then(function(mood) {
          message.close(mood.value)
        })
    }

    function flag(message) {
      if (message.userFlagged) {
        message.toggleFlag()
      } else {
        glDialog
          .show({
            templateUrl: 'confirm-dialog.template.html',
            controller: angular.noop,
            locals: {
              title: 'Flag Message',
              message:
                'Are you sure you want to flag this message as innappropriate?',
              confirmText: 'Confirm',
            },
          })
          .then(function() {
            message.toggleFlag()
          })
      }
    }

    function flagComment(comment) {
      if (comment.userFlagged) {
        comment.toggleFlag()
      } else {
        glDialog
          .show({
            templateUrl: 'confirm-dialog.template.html',
            controller: angular.noop,
            locals: {
              title: 'Flag Comment',
              message:
                'Are you sure you want to flag this comment as innappropriate?',
              confirmText: 'Confirm',
            },
          })
          .then(function() {
            comment.toggleFlag()
          })
      }
    }

    function share() {
      glDialog.show({
        templateUrl: 'message-share-dialog.template.html',
        controller: angular.noop,
        locals: {
          share: shareService.share,
        },
      })
    }

    function showSendDialog(options) {
      glDialog.show({
        templateUrl: 'message-send-dialog.template.html',
        controller: 'MessageSendDialog',
        locals: {
          options: options || {},
        },
      })
    }
  }
})()
